import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'
import { RequirePermission } from '@/auth/RequirePermission'
import { permissionCode } from '@/lib/permissions'

/**
 * Audit Plan routes.
 *
 * The list and read-only detail are gated by `audit_plan:view`; creating needs
 * `audit_plan:create` and editing needs `audit_plan:edit`. The review actions
 * (approve / return / archive) and permanent delete live behind their own
 * permission codes. Pages are code-split from `AppShell`'s suspense boundary.
 *
 * `archived` and `new` are declared before `:id` so the literal paths win.
 */
const AuditPlansPage = lazy(() => import('@/pages/audit-plan/AuditPlansPage'))
const ArchivedAuditPlansPage = lazy(() => import('@/pages/audit-plan/ArchivedAuditPlansPage'))
const AuditPlanCreatePage = lazy(() => import('@/pages/audit-plan/AuditPlanCreatePage'))
const AuditPlanDetailPage = lazy(() => import('@/pages/audit-plan/AuditPlanDetailPage'))
const AuditPlanEditPage = lazy(() => import('@/pages/audit-plan/AuditPlanEditPage'))

export const auditPlanRoutes: RouteObject[] = [
  {
    path: 'audit-plan',
    element: (
      <RequirePermission permission={permissionCode('audit_plan', 'view')}>
        <AuditPlansPage />
      </RequirePermission>
    ),
  },
  {
    path: 'audit-plan/archived',
    element: (
      <RequirePermission permission={permissionCode('audit_plan', 'view')}>
        <ArchivedAuditPlansPage />
      </RequirePermission>
    ),
  },
  {
    path: 'audit-plan/new',
    element: (
      <RequirePermission permission={permissionCode('audit_plan', 'create')}>
        <AuditPlanCreatePage />
      </RequirePermission>
    ),
  },
  {
    path: 'audit-plan/:id',
    element: (
      <RequirePermission permission={permissionCode('audit_plan', 'view')}>
        <AuditPlanDetailPage />
      </RequirePermission>
    ),
  },
  {
    path: 'audit-plan/:id/edit',
    element: (
      <RequirePermission permission={permissionCode('audit_plan', 'edit')}>
        <AuditPlanEditPage />
      </RequirePermission>
    ),
  },
]
